import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-487655bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-center mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-sm-12 login-container" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "bold mb-0" }, "Gotowe!"),
  /*#__PURE__*/_createElementVNode("p", { class: "registered-confirmation-text" }, " Potwierdź rejestrację klikając w link w mailu. "),
  /*#__PURE__*/_createElementVNode("p", { class: "registered-confirmation-small" }, " Automatycznie przeniesiemy Cię na stronę z kosztami napraw twojego samochodu. ")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col-md-12 col-sm-12 login-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Zarejestruj się", -1))
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_login_buttons = _resolveComponent("login-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRegistered)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.emailError }]),
                placeholder: "Email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
              }, null, 2), [
                [_vModelText, _ctx.email]
              ]),
              (_ctx.emailError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.emailError), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (_ctx.isSending)
                ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-gradient",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)))
                  }, " Zarejestruj się "))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_login_buttons, { "hide-registration": "" })
          ])
        ]))
  ]))
}